/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const noisey: CommunityData = {
  code: "noisey",
  inviteCode: "noiseyn",
  name: "Noisey Neighbours",
  thumbnail: "https://media.werz.at/web/noisey-thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/noi-133`,
  socials: {
    instagramLink: "https://www.instagram.com/noisey_neighbours/",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#32353E",
      alternativeLogo: {
        src: "/assets/customizations/nn/logo.svg",
        styles: "w-[159px]",
      },
      logo: {
        src: "/assets/customizations/nn/logo.svg",
        styles: "w-[333px] h-[88px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#5A154D",
      asideStyles: "",
      asideBg: "#322E2D",
      contentBg: "linear-gradient(0deg,#FFFFFF,#FFFFFF),#AC9994",
      contentBoxShadow: "shadow-[0px_4px_4px_rgba(0,0,0,0.25)]",
      bgDesktop: "/assets/customizations/nn/nn-bg.png",
      bgMobile: "/assets/customizations/nn/nn-bg.png",
      mainFont: "font-['Hando']",
      primaryButton:
        "w-full sm:w-fit !h-[50px] bg-[#1D1A1A] !px-6 !text-base !leading-[1] font-['Hando'] !font-black !text-[#FFDA00] whitespace-nowrap uppercase rounded-[100px] !pt-[3px]",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#FFDA00",
      separator: "border-[#413B3A] border-t",
      item: "font-['Hando'] text-[18px] leading-[18px] h-[40px] flex items-center sm:justify-start justify-center uppercase text-[#FFDA00] font-semibold !pt-2",
      itemSelected: "bg-[#46403F] text-[#FFDA00]",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles:
        "font-['Arcade'] uppercase text-[#1D1A1A] text-[24px] font-normal leading-[24px] pb-2",
      announcements: {
        customBg: "bg-[#261815]",
        lg: {
          title: "text-[20px] sm:text-[24px] leading-[1] font-semibold font-['Hando'] mb-1",
          subtitle: "text-[13px] leading-[1] font-normal text-[#FFFFFF]",
        },
        sm: {
          title: "text-[20px] sm:text-base leading-[1] mb-2",
          subtitle: "text-[14px] leading-[1] font-normal text-[#FFFFFF]",
        },
      },
      event: {
        title: "text-base !font-medium leading-[0.8] sm:leading-[1] text-[#1D1A1A]",
        subtitle: "text-base leading-[20px] text-[#1D1A1A] !font-normal",
      },
      shop: {
        title: "text-[20px] leading-[1] font-normal text-[#1D1A1A]",
        text: "text-base leading-5 text-[#1D1A1A]",
        customShopImage: "/assets/customizations/nn/img_shop.png",
      },
    },
    announcements: {
      created: "",
      emptyOrLoadingState: "font-bold text-[20px] leading-[20px]",
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "font-['Arcade'] uppercase text-[#1D1A1A] text-[24px] font-normal leading-[24px]",
      title: "uppercase text-[#1D1A1A] text-[24px] font-normal leading-[24px] pb-2",
      description: "text-[14px] leading-[14px] font-normal",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      emptyOrLoadingState: "font-bold text-[20px] leading-[20px]",
      created: "",
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      title: "uppercase text-[#1D1A1A] text-[24px] font-normal leading-[24px] pb-2",
      description: "text-[14px] leading-[14px] font-normal",
      commentIconColor: "",
      likeIconColor: "",
    },
    events: {
      sectionHeader: "uppercase",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "font-['Arcade'] uppercase text-[#1D1A1A] text-[24px] font-normal leading-[24px]",
      title: "font-['Arcade'] uppercase text-[#1D1A1A] text-[24px] font-normal leading-[24px] py-2",
      emptyOrLoadingState: "font-bold text-[20px] leading-[20px] my-8",
      duration: "font-medium text-[14px] leading-[14px]  mb-4",
      address: "text-[12px] leading-[12px] uppercase",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-black",
    },
    event: {
      emptyOrLoadingState: "font-bold text-[20px] leading-[20px] my-8",
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      sectionTitle: "text-[32px] font-normal leading-10 font-['Arcade'] text-[#1D1A1A] uppercase",
      sectionSubtitle: "text-[12px] leading-[12px] font-medium text-[#1D1A1A] uppercase",
      text: "text-[16px] leading-5 text-[#1D1A1A] ",
      separator: "mb-8 mt-6 border-b border-b-[1px] border-black",
      header:
        "font-['Arcade'] uppercase text-[#1D1A1A] text-[32px] font-normal leading-[32px] sm:mb-0 mb-5",
      map: {
        pin: "",
        border: "sm:mb-0 mb-2",
        pinColor: "#1D1A1A",
        strokeColor: "border-[#1D1A1A]",
      },
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      separator: "mb-8 mt-6 border-b border-b-[1px] border-black",
      event: {
        title:
          "text-[32px] font-normal leading-[32px] font-['Arcade'] text-[#1D1A1A] uppercase sm:mt-2 mt-0 mb-0 sm:ml-1",
        subtitle: "text-[12px] leading-[12px] font-medium text-[#1D1A1A uppercase sm:ml-1",
      },
      ticket: {
        counterContainer: "",
        title: "text-[24px] uppercase leading-7 text-[#1D1A1A] font-['Arcade']",
        description: "text-[14px] leading-[14px] font-['Hando']",
        text: "text-[14px] leading-[14px] font-['Hando']",
        price: "text-[14px] leading-[14px] font-['Hando']",
        quantity: "text-[14px] leading-[14px] font-['Hando']",
      },
    },
    shop: {
      sectionTitle: "uppercase",
      separator: "mt-2 sm:mb-7 mb-6 border-b border-b-[1px] border-black",
      container: "mb-16 sm:p-11 p-7 sm:pb-8",
      emptyState: "font-bold text-[20px] leading-[20px] my-8",
      header: "font-['Arcade'] uppercase text-[#1D1A1A] text-[24px] font-normal leading-[24px]",
    },
  },
}

export default noisey
